import { Button, Form, IFormRender } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { ClassName } from "types/ClassName";
import { useToastOpen } from 'contexts/ToastContext';
import { usePositionUpdate } from 'hooks';
import { t } from 'i18next';
import { isEqual } from 'lodash';
import { useRef } from 'react';
import { EquipmentSelectionOptions } from '__generated__/graphql';
import RequireEquipmentFormFields, {
  IRequireEquipmentFormFieldsData,
} from '../components/RequireEquipmentFormFields/RequireEquipmentFormFields';
import { RequireEquipmentFormHeaderText } from '../components/RequireEquipmentFormHeaderText/RequireEquipmentFormHeaderText';

export interface IRequireEquipmentFormProps {
  positionId: string;
  onSubmit: (requireEquipmentKey: EquipmentSelectionOptions) => void;
  currentSetting: EquipmentSelectionOptions;
  className?: ClassName;
}

export default function RequireEquipmentForm({
  positionId,
  onSubmit,
  currentSetting,
  className,
}: IRequireEquipmentFormProps) {
  const initialFormData = useRef<IRequireEquipmentFormFieldsData>({ equipmentSelectionRequirement: currentSetting });
  const [, update] = usePositionUpdate();
  const openToast = useToastOpen();

  async function onFormSubmit(formData: IRequireEquipmentFormFieldsData) {
    const updatedValue = formData.equipmentSelectionRequirement;

    if (!isEqual(currentSetting, updatedValue)) {
      try {
        await update({ id: positionId, equipmentSelectionRequirement: updatedValue });
      } catch (e) {
        openToast({ label: t('Something went wrong. Please try again later.') });
      }
    }

    onSubmit(updatedValue);
  }

  function renderFormFields(form: IFormRender<IRequireEquipmentFormFieldsData>) {
    return (
      <>
        <RequireEquipmentFormFields form={form} />
        <Button type="primary" onClick={form.handleSubmit}>
          {t('Update')}
        </Button>
      </>
    );
  }

  const classes = classNames('require-equipment-form', className);

  return (
    <div className={classes}>
      <RequireEquipmentFormHeaderText />
      <Form render={renderFormFields} onSubmit={onFormSubmit} data={initialFormData.current} />
    </div>
  );
}
